import { createContext } from "react";

export const VisualActivityContext = createContext(true);
